import { elakay_API } from "../../config";

export const sendMessageHelp = (token, Message) => {
   
    return fetch(`${elakay_API}/SendMessagHelp/send`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(Message)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const GetMessageHelp = (token, Message, SMStrue) => {
    
    return fetch(`${elakay_API}/getMessagHelp?Message=${Message}&SMStrue=${SMStrue}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
}; 

const authHeaders = (token) => ({
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
});

export const getMessagePermissions = (token) => {
    return fetch(`${elakay_API}/messages/permissions`, {
        method: "GET",
        headers: authHeaders(token)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};

export const getMessageContacts = (token) => {
    return fetch(`${elakay_API}/messages/contacts`, {
        method: "GET",
        headers: authHeaders(token)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};

export const getSupportResponsibles = (token, topic) => {
    const safeTopic = encodeURIComponent(topic || "general");

    return fetch(`${elakay_API}/support/responsibles?topic=${safeTopic}`, {
        method: "GET",
        headers: authHeaders(token)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};

export const saveSupportChatHistory = (token, payload) => {
    return fetch(`${elakay_API}/support/chat-histories`, {
        method: "POST",
        headers: authHeaders(token),
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};

export const getSupportChatHistories = (token) => {
    return fetch(`${elakay_API}/support/chat-histories`, {
        method: "GET",
        headers: authHeaders(token)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};

export const restoreSupportChatHistory = (token, historyId) => {
    return fetch(`${elakay_API}/support/chat-histories/${historyId}`, {
        method: "GET",
        headers: authHeaders(token)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};

export const deleteSupportChatHistory = (token, historyId) => {
    return fetch(`${elakay_API}/support/chat-histories/${historyId}`, {
        method: "DELETE",
        headers: authHeaders(token)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};

export const deleteAllSupportChatHistories = (token) => {
    return fetch(`${elakay_API}/support/chat-histories`, {
        method: "DELETE",
        headers: authHeaders(token)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};

// Vue admin (ChatbotDashboard, onglet "Messages clients") : un message par
// ligne (toutes conversations), avec un grand filtre (sender, topic,
// langue, fournisseur, texte, client, dates) + pagination skip/limit.
export const getAdminCustomerMessages = (token, params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") query.set(key, value);
    });
    const search = query.toString() ? `?${query.toString()}` : "";

    return fetch(`${elakay_API}/support/admin/messages${search}`, {
        method: "GET",
        headers: authHeaders(token)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};

// Questions les plus posees (texte normalise), triables par nombre
// d'occurrences (sortOrder: "asc" | "desc") + pagination skip/limit.
export const getAdminTopQuestions = (token, params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") query.set(key, value);
    });
    const search = query.toString() ? `?${query.toString()}` : "";

    return fetch(`${elakay_API}/support/admin/messages/top-questions${search}`, {
        method: "GET",
        headers: authHeaders(token)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};

export const askSupportAssistant = (token, payload, timeout = 12000) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);

    return fetch(`${elakay_API}/support/ai-reply`, {
        method: "POST",
        headers: authHeaders(token),
        body: JSON.stringify(payload),
        signal: controller.signal
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.name === "AbortError"
                ? "L'assistant met trop de temps à répondre."
                : (err.message || "Une erreur inconnue est survenue")
        }))
        .finally(() => clearTimeout(timer));
};

export const getMessages = (token, recipientId) => {
    const query = recipientId ? `?recipientId=${recipientId}` : "";

    return fetch(`${elakay_API}/messages${query}`, {
        method: "GET",
        headers: authHeaders(token)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};

export const sendMessage = (token, Message) => {
    return fetch(`${elakay_API}/messages/send`, {
        method: "POST",
        headers: authHeaders(token),
        body: JSON.stringify(Message)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};

export const markMessageRead = (token, messageId) => {
    return fetch(`${elakay_API}/messages/${messageId}/read`, {
        method: "PATCH",
        headers: authHeaders(token)
    })
        .then(response => response.json())
        .catch(err => ({
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        }));
};
